import { render, staticRenderFns } from "./RolesServiceAddEdit.vue?vue&type=template&id=660d3513&scoped=true&"
import script from "./RolesServiceAddEdit.vue?vue&type=script&lang=js&"
export * from "./RolesServiceAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./RolesServiceAddEdit.vue?vue&type=style&index=0&id=660d3513&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660d3513",
  null
  
)

export default component.exports